import React from 'react';
const AuthApi = React.createContext({autenticacion:false,rol:'',id:'',nombre:''});
export default AuthApi;
